import { ThemeProvider } from '../contexts/theme/ThemeContext';

export const AppState = ({ children }: any) => {
  return <ThemeProvider>{children}</ThemeProvider>;
};
